import { render, staticRenderFns } from "./MobileButton.vue?vue&type=template&id=0be8feec&scoped=true"
import script from "./MobileButton.vue?vue&type=script&lang=js"
export * from "./MobileButton.vue?vue&type=script&lang=js"
import style0 from "./MobileButton.vue?vue&type=style&index=0&id=0be8feec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be8feec",
  null
  
)

export default component.exports